import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageOptimizerDirective } from 'lazy-load-image';
import { MsFormBuilerModule } from 'ms-form-builder';

@Component({
  selector: 'app-shahrak-form-layout',
  templateUrl: './shahrak-form-layout.component.html',
  styleUrls: ['./shahrak-form-layout.component.scss'],
  imports: [MsFormBuilerModule, RouterModule, ImageOptimizerDirective],
})
export class ShahrakFormLayoutComponent {
  goBack() {
    // UnitsRoute.map.mainpage.bdsp_unit_landing.navigate();
  }
}
